/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Dashboard, ExportedDashboardsDocument, GmcError, Widget, WidgetMetadata } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { DashboardGroup, WidgetType } from '@shared/types/common';

export const dashboard = createAction(
  '[Dashboard] Dashboard',
  props<{ dashboardGroupName?: string; dashboard: Dashboard }>(),
);
export const dashboardErr = createAction('[Dashboard] Dashboard Failure', props<GmcError>());
export const dashboardGroup = createAction('[Dashboard] Dashboard group', props<{ dashboardGroup: DashboardGroup }>());
export const updateDashboardGroup = createAction(
  '[Dashboard] Update dashboard group',
  props<{ name: string; ids: string[] }>(),
);
export const dashboardGroupErr = createAction('[Dashboard] Dashboard group Failure', props<GmcError>());
export const dashboardMetadataChange = createAction(
  '[Dashboard] Dashboard metadata change',
  props<{ dashboard: Dashboard; dashboardGroupName: string }>(),
);
export const dashboardMetadataChangeErr = createAction(
  '[Dashboard] Dashboard metadata change Failure',
  props<GmcError>(),
);
export const removeDashboard = createAction(
  '[Dashboard] Remove dashboard',
  props<{ dashboardGroupName: string; dashboardIds: string[] }>(),
);
export const removeDashboardOk = createAction(
  '[Dashboard] Remove dashboard Success',
  props<{ dashboardGroupName: string; dashboardId: string }>(),
);
export const removeDashboardErr = createAction('[Dashboard] Remove dashboard Failure', props<GmcError>());
export const renameDashboard = createAction(
  '[Dashboard] Rename dashboard',
  props<{ dashboardGroupName: string; dashboardId: string }>(),
);
export const addDashboard = createAction(
  '[Dashboard] Add dashboard',
  props<{ dashboardGroupName: string; dashboard: Dashboard }>(),
);
export const addDashboardErr = createAction('[Dashboard] Add dashboard Failure', props<GmcError>());
export const cloneDashboard = createAction(
  '[Dashboard] Clone dashboard',
  props<{ dashboardGroupName: string; dashboardId: string }>(),
);

export const widgetMetadataChange = createAction(
  '[Dashboard] Widget metadata change',
  props<{ dashboardGroup: string; dashboardId: string; widgetId: string; metadata: WidgetMetadata<WidgetType> }>(),
);
export const widgetMetadataChangeErr = createAction('[Dashboard] Widget metadata change Failure', props<GmcError>());
export const addWidget = createAction(
  '[Dashboard] Add Widget',
  props<{ dashboardGroup: string; dashboardId: string; widget: Widget }>(),
);
export const addWidgetErr = createAction('[Dashboard] Add Widget Failure', props<GmcError>());
export const removeWidget = createAction(
  '[Dashboard] Remove widget',
  props<{ dashboardGroup: string; dashboardId: string; widgetId: string }>(),
);
export const removeWidgetErr = createAction('[Dashboard] Remove widget Failure', props<GmcError>());

export const fitWidgets = createAction(
  '[Dashboard] Fit widgets',
  props<{ dashboardGroupName: string; dashboardId: string }>(),
);

export const importDashboards = createAction(
  '[Dashboard] Import dashboards',
  props<{ dashboardGroupName: string; dashboardDocument: ExportedDashboardsDocument }>(),
);
